import { Box, Stack } from "@mui/material";
import { DataGridPro, type GridColDef, type GridRenderCellParams } from "@mui/x-data-grid-pro";
import { type FC, useMemo } from "react";
import { AnalyticsDatetime } from "../../../utils/analytics-datetime";
import { ReactionAvatar } from "./reaction-avatar";
import type { ReactionsByPerson } from "./types";

type RowType = ReactionsByPerson["reactions"][0] & { id: number };

export const NestedPersonTable: FC<{ row: ReactionsByPerson }> = ({ row }) => {
  const columns: GridColDef<RowType>[] = useMemo(
    () => [
      {
        field: "reaction",
        headerName: "Emoji",
        flex: 0.5,
        renderCell: (params: GridRenderCellParams<RowType, RowType["reaction"]>) => (
          <ReactionAvatar reaction={params.value} />
        ),
      },
      {
        field: "timestamp",
        headerName: "Reaction Time",
        flex: 4,
        type: "dateTime",
        renderCell: (params: GridRenderCellParams<RowType, Date>) =>
          params.value ? (
            <Stack direction="row" spacing={1} alignItems="center" height="100%">
              <AnalyticsDatetime datetime={params.value} />
            </Stack>
          ) : null,
      },
    ],
    [],
  );

  const reactions = useMemo(
    () => row.reactions.map((reaction, index) => ({ id: index, ...reaction })),
    [row],
  );

  return (
    <Box sx={{ ml: "50px" }}>
      <DataGridPro
        hideFooterRowCount
        rows={reactions}
        columns={columns}
        disableRowSelectionOnClick
      />
    </Box>
  );
};
